import React, { useState, useEffect } from "react";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { api_path } from "../../shared.js";

function CompaignMasterDetailView({
  data,
  selectedMetric,
  selectedCampaignId,
}) {
  const [detailData, setDetailData] = useState([]);
  const token = process.env.REACT_APP_API_TOKEN;
    const campaignId = data?.CAMPAIGN_ID; // ✅ ดึงจาก master row ที่เปิดอยู่

  useEffect(() => {
    if (!campaignId) return;

    const url = selectedMetric
      ? `${api_path}/customer/customers.php?campaign_id=${campaignId}&filter=${selectedMetric}`
      : `${api_path}/customer/customers.php?campaign_id=${campaignId}`;

    console.log("🔍 Loading detail from:", url);

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((res) => setDetailData(res))
      .catch((err) => console.error("Fetch error:", err));
  }, [campaignId, selectedMetric]); // ✅ trigger เมื่อเปิด detail หรือ metric เปลี่ยน

  const cellPrepared = (e) => {
    if (e.rowType !== "data") return;
    const yesNoIcon = (val) => (val ? "✔️" : "❌");
    const field = e.column.dataField;
    const rowData = e.data; // ข้อมูลทั้งแถว
    const smfCode = rowData.SMF_CUSCODE;
    if (field === "CUSTOMER_STATUS_EN") {
      e.cellElement.innerHTML = `<span class='status-button badge badge-status-${e.data[
        field
      ]
        .toLowerCase()
        .replace(/[\s()]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}'><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #fff;'>${
        e.data[field]
      }</a></span>`;
    }

     if (field === "CUSTOMER_NAME") {
      e.cellElement.innerHTML = `<span><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #000;'>${
        e.data[field]
      }</a></span>`;
    }
     if (field === "CRM_CUSCODE") {
      e.cellElement.innerHTML = `<span><a href='Customer?customer_id=${
        e.row.key
      }&code=${smfCode}' target='_blank' style='color: #000;'>${
        e.data[field]
      }</a></span>`;
    }
  };

  return (
    <div style={{ padding: "10px" }}>
      <h4>
        {selectedMetric} for Campaign #{selectedCampaignId}
      </h4>

      <DataGrid
        dataSource={detailData} // ใช้ข้อมูลจาก state เลย
        keyExpr="CRM_CUSCODE"
        showBorders={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        onCellPrepared={cellPrepared}
        searchPanel={{ visible: false }}
        filterRow={{ visible: true }}
      >
        <Column dataField="CRM_CUSCODE" caption="CRM CODE" />
        <Column dataField="CUSTOMER_NAME" caption="NAME" />
        <Column dataField="CUSTOMER_STATUS_EN" caption="STAGE" />
        <Column dataField="GLOBAL_TIER_EN" caption="TIER" />
        <Column dataField="CUSTOMER_TYPE_EN" caption="TYPE" />
        <Column dataField="SALES_NAME" caption="SALES" />
      </DataGrid>
    </div>
  );
}

export default CompaignMasterDetailView;
